import { canv } from "@/canv/global.js";
import type { ExtendsOfElementBase } from "@/canvasController/types";
import type { DocumentViewerWidget, ViewMode } from "@/elements/documentViewer/DocumentViewer";
import { wmBase } from "@/widgetMenu/wmBase";

export class WmDocumentDownload extends wmBase {
    build() {
        return `
            <div class="wm_documentDownload">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13M5 8L10 13M10 13L15 8M10 13V1" stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
        `;
    }

    init() {
        const item = document.querySelector(".wm_documentDownload");
        item?.removeEventListener("click", this.itemClick, false);
        item?.addEventListener("click", this.itemClick, false);
    }

    itemClick = (): void => {
        const selectedEntities = canv.canvasController.selected;
        function isDocumentViewer(obj: ExtendsOfElementBase): obj is DocumentViewerWidget {
            return obj?.constructorName === "documentViewer";
        }

        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild() as ExtendsOfElementBase | null;
            if (child && isDocumentViewer(child)) {
                child.downloadDocument();
            }
        }
    };
}
